// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { companyApi } from '../apis/company.api';

// action
import { actions } from '../actions/company.actionV2';

// models
import type { ResultError } from 'modules/common';
import type {
  ReqCompanyDetail,
  ReqCompanyList,
  ResCompanyDetail,
  ResCompanyList
} from '../models/company.model';

/**
 * 업체 조회 API
 * 업체 페이지를 조회합니다.
 *
 * keyword 검색 범위 : 회사명, 대표자 이름, 프로젝트 매니저 이름, 회사 타입, 공종명
 * 설계서 : [UAE_GSIL] Company Management_PC_화면설계서(v1.0)_24.10.08
 * 페이지 : 10P
 * 화면ID : CM_W_01
 */
export const getCompanyListV2 = createAsyncThunk<
  ResCompanyList,
  ReqCompanyList,
  {
    rejectValue: ResultError;
  }
>(actions.GET_COMPANY_LIST, async (data, { fulfillWithValue, rejectWithValue }) => {
  try {
    const res = await companyApi.getCompany(data);

    return fulfillWithValue(res);
  } catch (error) {
    const err = error as ResultError;

    return rejectWithValue(err);
  }
});

/**
 * 업체 상세 조회 API
 * companyId 를 통해 업체 상세 정보를 조회합니다.
 *
 * 설계서 : [UAE_GSIL] Company Management_PC_화면설계서(v1.0)_24.10.08
 * 페이지 : 13P
 * 화면ID : CM_WP_01
 */
export const getCompanyDetailV2 = createAsyncThunk<
  ResCompanyDetail,
  ReqCompanyDetail,
  {
    rejectValue: ResultError;
  }
>(actions.GET_COMPANY_DETAIL, async (data, { fulfillWithValue, rejectWithValue }) => {
  try {
    const res = await companyApi.getCompanyDetail(data);

    return fulfillWithValue(res);
  } catch (error) {
    const err = error as ResultError;

    return rejectWithValue(err);
  }
});
